<template>
  <footer class="mastfoot">
    <router-link :to="{name: 'Home'}">
      <img class="brand" src="@/assets/images/VTStack_logo_blanc.svg" alt="logo vtstack white">
    </router-link>
    <a target="_blank" href="https://www.seriousfactory.com">
      <div class="title">
        SERIOUS
        <span class="semibold">FACTORY </span>
        SAS © {{new Date().getFullYear()}}
      </div>
    </a>
  </footer>
</template>
<script>
export default {
  name: 'TheFooter',
};
</script>
